import { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import {
  COOKIE_INTEGRATION_BW_CENTRAL,
  COOKIE_INTEGRATION_NAME,
  EXPIRE_DATE_TOKEN_NAME,
  generateSSOpathLogout,
  LOCALSTORAGE_TOKEN_NAME
} from 'modules/auth/auth.constants'
import { checkToken } from 'modules/auth/auth.requests'
import { trace } from 'utils/trace'

import { APP_ROUTES } from 'src/app/routes/routes.constants'
import { clearCookies } from 'modules/auth/auth.service'

export const generateSSOpath = () =>
  `${process.env.URL_SSO}/login?service=${encodeURI(
    `${location.origin}${APP_ROUTES.cas.login}`
  )}&systemOrigin=app-business-workspace`

export const useCheckToken = (shouldntCheckToken: boolean) => {
  const [isCheckingToken, setIsChecking] = useState(true)
  const THE_TOKEN = Cookies.get(COOKIE_INTEGRATION_BW_CENTRAL) || Cookies.get(COOKIE_INTEGRATION_NAME)
  const THE_EXPIRE_DATE_TOKEN = Cookies.get(EXPIRE_DATE_TOKEN_NAME)?.split('|')[0]
  const TOKEN_EXPIRED = new Date(Number(THE_EXPIRE_DATE_TOKEN) * 1000) < new Date()

  useEffect(() => {
    if (shouldntCheckToken) {
      return
    }

    if (!THE_TOKEN) {
      clearCookies()
      window.location.href = generateSSOpath()
      return
    }

    if (THE_EXPIRE_DATE_TOKEN) {
      if (TOKEN_EXPIRED) {
        trace.trhowMsg(`[trace][4], expired date: ${THE_EXPIRE_DATE_TOKEN}`)
        localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME)
        clearCookies()
        window.location.href = generateSSOpathLogout()
      } else {
        setIsChecking(false)
      }
      return
    }

    checkToken(encodeURIComponent(THE_TOKEN)).then(payload => {
      if (payload) {
        setIsChecking(false)
      }
    })
  }, [shouldntCheckToken])

  return {
    isCheckingToken
  }
}
